/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getorderDetails, getorderProductDetails, cancelOrders, confirmTheReceiptOfGoods, getTransferInformation, deleOrder, getShopOrderPaymentInfo, getShopPaymentModeList, getproductDetails } from '@/api';
import SinglePicker from '@/components/Base/SinglePicker';
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import SmyMapAddress from '@/components/CustomFormList/SmyMapAddress';
import { wxJsApiPay } from '@/utils/onlinePay';
import { mapMutations } from 'vuex';
export default {
  name: 'determineOrder',
  props: {
    id: [String, Number]
  },
  components: {
    Group: Group,
    SmyMapAddress: SmyMapAddress,
    SinglePicker: SinglePicker
  },
  data: function data() {
    return {
      columns: [],
      payId: '',
      from: {},
      orderData: [],
      orderStatus: [{
        order_type: 1,
        name: i18n.tc("642")
      }, {
        order_type: 2,
        name: i18n.tc("643")
      }, {
        order_type: 3,
        name: i18n.tc("644")
      }, {
        order_type: 4,
        name: i18n.tc("645")
      }, {
        order_type: 5,
        name: i18n.tc("389")
      }, {
        order_type: 6,
        name: i18n.tc("66")
      }, {
        order_type: 0,
        name: i18n.tc("646")
      }]
    };
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_pageReload'])), {}, {
    goBook: function goBook(item) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getproductDetails({
                  fk_t_shop_goods_id: item.fk_t_shop_goods_id
                });
              case 2:
                res = _context.sent;
                if (res.success) {
                  _this.$router.push({
                    name: 'Appointment',
                    query: {
                      id: res.data.object_id,
                      shopId: item.id
                    }
                  });
                } else {
                  _this.$vux.toast.text(res.message || i18n.tc("647"));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    goBookRecord: function goBookRecord() {
      this._pageReload({
        order: true
      });
      this.$router.push({
        name: 'ProjectBelong',
        query: {
          shopOrderId: this.id
        }
      });
    },
    payOrder: function payOrder() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.payId) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return", _this2.$vux.toast.text(i18n.tc("648")));
              case 2:
                getShopOrderPaymentInfo({
                  receivePaymentId: _this2.payId,
                  shopOrderId: _this2.id
                }).then(function (res) {
                  if (res.success) {
                    wxJsApiPay(res.data.voucher).then(function () {
                      _this2.$vux.toast.text(i18n.tc("649"));
                      _this2.getData();
                    }).catch(function (e) {
                      console.log('AutoConsole: payOrder -> e', e);
                      _this2.$vux.toast.text(i18n.tc("650"));
                    });
                  } else {
                    _this2.$vux.toast.text(res.message);
                  }
                });
              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onConfirm: function onConfirm(value) {
      this.from.pay_method = value;
      this.showPicker = false;
    },
    getData: function getData() {
      var _this3 = this;
      getorderDetails({
        fk_t_shop_order_id: this.$route.params.id
      }).then(function (res) {
        if (res.success) {
          _this3.from = res.data;
        }
      });
    },
    getDatas: function getDatas() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getorderProductDetails({
                  fk_t_shop_order_id: _this4.$route.params.id
                });
              case 2:
                res = _context3.sent;
                if (res.success) {
                  _this4.orderData = res.data;
                }
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    calOrder: function calOrder() {
      var _this5 = this;
      cancelOrders({
        fk_t_shop_order_id: this.from.fk_t_shop_order_id
      }).then(function (res) {
        if (res.success) {
          _this5.$vux.toast.text(i18n.tc("651"));
          _this5.$router.go(-1);
        }
      });
    },
    confirm: function confirm() {
      var _this6 = this;
      confirmTheReceiptOfGoods({
        fk_t_shop_order_id: this.from.fk_t_shop_order_id
      }).then(function (res) {
        if (res.success) {
          _this6.$vux.toast.text(i18n.tc("652"));
          _this6.$router.go(-1);
        }
      });
    },
    goInformation: function goInformation() {
      var _this7 = this;
      getTransferInformation({
        fk_t_shop_order_id: this.from.fk_t_shop_order_id
      }).then(function (res) {
        if (res.success) {
          _this7.$router.push({
            name: 'offline',
            params: {
              data: res.data
            }
          });
        }
      });
    },
    delOrder: function delOrder() {
      var _this8 = this;
      console.log(1);
      deleOrder({
        fk_t_shop_order_id: this.from.fk_t_shop_order_id
      }).then(function (res) {
        if (res.success) {
          _this8.$vux.toast.text(i18n.tc("486"));
          _this8.$router.go(-1);
        }
      });
    },
    fillIn: function fillIn() {
      console.log(this.from);
      this.$router.push({
        name: 'offline',
        params: {
          id: this.from.fk_t_shop_order_id,
          price: this.from.totle_amount
        }
      });
    },
    copy: function copy() {
      var input = document.createElement('input');
      //将input的值设置为需要复制的内容
      input.value = this.pay;
      //添加input标签
      document.body.appendChild(input);
      //选中input标签
      input.select();
      //执行复制
      document.execCommand('copy');
      //成功提示信息
      this.$vux.toast.text(i18n.tc("635"));
      //移除input标签
      document.body.removeChild(input);
    }
  }),
  computed: {
    state: function state() {
      var _this9 = this;
      if (this.from.order_type) {
        return this.orderStatus.find(function (item) {
          return item.order_type == _this9.from.order_type;
        }).name;
      }
      return '';
    }
  },
  created: function created() {
    var _this10 = this;
    this.getData();
    this.getDatas();
    getShopPaymentModeList().then(function (res) {
      if (res.success) {
        _this10.columns = res.data.map(function (v) {
          return {
            name: v.receive_payment_name,
            id: v.fk_t_ep_receive_payment_id
          };
        });
        if (res.data[0]) {
          _this10.payId = res.data[0].fk_t_ep_receive_payment_id;
        }
      }
    });
  }
};